import type { IFilterableListItem, IOmit, ISelectProps } from '@sixui/ui';
import { forwardRef } from 'react';
import { Select } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

export type IAppRoleSelectorProps = IOmit<ISelectProps, 'items'>;

export const AppRoleSelector = forwardRef<
  HTMLDivElement,
  IAppRoleSelectorProps
>(function AppRoleSelector(props, forwardedRef) {
  const { ...other } = props;
  const { t } = useTranslation();
  const items: Array<IFilterableListItem> = [
    {
      value: 'viewer',
      supportingText: t('AppRoleSelector.viewer.supporting-text'),
      disabled: true,
    },
    {
      value: 'editor',
      supportingText: t('AppRoleSelector.editor.supporting-text'),
      disabled: true,
    },
    {
      value: 'moderator',
      supportingText: t('AppRoleSelector.moderator.supporting-text'),
      disabled: true,
    },
    {
      value: 'admin',
      supportingText: t('OrganizationRoleSelector.admin.supportingText'),
    },
  ];

  return <Select {...other} items={items} ref={forwardedRef} />;
});
